import React from 'react'
import { UseHeader, MktEmpty, PointCardItem } from '@cps'
import { IonContent, IonPage, useIonViewWillEnter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { pointCardMobx, memberMobx } from '@mobxStore'
import mktController from 'controllers/mktController'
import { observer } from 'mobx-react'
import { useHistoryNew } from '@utils'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const IPointCardList: React.FC<IProps> = () => {
  const history = useHistoryNew()
  const { pointCardList } = pointCardMobx
  const onBack = () => {
    mktController.goBack(history)
  }
  useIonViewWillEnter(() => {
    if (memberMobx.isLogin) {
      pointCardMobx.getPointCardList()
    } else {
      setTimeout(() => {
        history.push('/login')
      }, 0)
    }
  })
  return (
    <IonPage className='my-point-card'>
      <UseHeader
        title={i18n.t('mkt.pointCard.title')}
        onBack={onBack}
      >
      </UseHeader>
      <IonContent>
        {pointCardList.length > 0 ? (
          <div className='point-card-list-content'>
            {pointCardList.map((item) => (
              <div className='point-card-block' key={item.activityId}>
                <PointCardItem
                  data={item}
                  onClick={() =>
                    history.push(`pointCard/detail/${item.activityId}`)}
                />
              </div>
            ))}
          </div>
        ) : (
          <MktEmpty></MktEmpty>
        )}
      </IonContent>
    </IonPage>
  )
}

export default observer(IPointCardList)
